var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__PrimaryActionWrapper" },
                  [
                    _vm.notificationConfig.welcomeNotification
                      ? _c(
                          "div",
                          {
                            staticClass: "Polaris-Box Polaris-Box--printHidden"
                          },
                          [
                            _vm.notificationConfig.welcomeNotification.isEnabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "Polaris-Button",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.updateNotificationConfig(
                                          false
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "Polaris-Button__Content"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "Polaris-Button__Text"
                                          },
                                          [_vm._v("Deactivate")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.notificationConfig.welcomeNotification
                              .isEnabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "Polaris-Button Polaris-Button--primary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.updateNotificationConfig(
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "Polaris-Button__Content"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "Polaris-Button__Text"
                                          },
                                          [_vm._v("Activate")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [_c("router-view")]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }